import { CircularProgress, Box, Typography } from '@mui/material';
import { useEffect } from 'react';
import './loading.css';
import { useAppSelector } from '../../shared/redux/store';

interface LoadingProps {
  isLoading?: boolean
}

const Loading:React.FC<LoadingProps> = ({ isLoading }) => {
  const loading = useAppSelector((state) => state.loading);

  useEffect(() => {
    const handleBeforeUnload = (event: Event) => {
      if (loading.value) {
        event.preventDefault();
        // event.returnValue is deprecated
        // event.returnValue = '';
      }
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [loading.value]);

  return (
    <>
      {(loading.value || isLoading) &&
        <div className="Loading-Wrapper">
          <Box className="Loading-Box">
            <CircularProgress color="primary"/>
            <Typography color="primary">{loading.text}</Typography>
          </Box>
        </div>
      }
    </>
  );
};

export default Loading;
